import React from "react";
import PublicLayout from "../components/PublicLayout";
import { BookOpen, HandHeart, Truck, Camera, GraduationCap } from "lucide-react";

export default function About() {
  const steps = [
    { icon: <BookOpen size={18}/>, title: "A school asks", body: "They register, upload a private student list, and submit for admin review. Student identities stay private — only counts go public." },
    { icon: <HandHeart size={18}/>, title: "Sponsors purchase book sets", body: `Minimum 20 sets keeps logistics fair. Payments are verified on our server before we count the purchase.` },
    {
      icon: <Truck size={18}/>,
      title: "We print, ship & enable learning",
      body: (
        <>
          <p>Admin triggers a print batch, assigns a tracking ID, and the school confirms receipt on arrival.</p>
          <div className="mt-4 flex items-start gap-3 p-4 rounded-md bg-[var(--bb-terracotta)]/8 border border-[var(--bb-terracotta)]/25" data-testid="how-step-train-trainer">
            <GraduationCap size={20} className="text-[var(--bb-terracotta)] shrink-0 mt-0.5" />
            <p>
              In addition, a <strong>Train-the-Trainer</strong> program is conducted for teachers —
              helping them effectively use Bala Basava comics and vachanas in classrooms.
            </p>
          </div>
          <p className="mt-3 text-sm text-[var(--bb-muted)] italic">This ensures the books are not just distributed, but actively used for value-based learning.</p>
        </>
      ),
    },
    { icon: <Camera size={18}/>, title: "Proof lands in your dashboard", body: "The school uploads photos and videos from distribution day." },
  ];
  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-16">
        <div className="bb-overline text-[var(--bb-terracotta)] mb-3">HOW IT WORKS</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[var(--bb-forest)] tracking-tight leading-[1.05] max-w-3xl">No middle layer. No guesswork. Just four steps.</h1>

        <div className="mt-14 space-y-10">
          {steps.map((s, i) => (
            <div key={s.title || i} className="grid md:grid-cols-12 gap-6 md:gap-10 items-start" data-testid={`how-step-${i}`}>
              <div className="md:col-span-1 font-serif text-6xl text-[var(--bb-terracotta)]/30 leading-none">{String(i+1).padStart(2,"0")}</div>
              <div className="md:col-span-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[var(--bb-forest)]/8 text-[var(--bb-forest)] grid place-items-center">{s.icon}</div>
                <h3 className="font-serif text-2xl text-[var(--bb-forest)]">{s.title}</h3>
              </div>
              <div className="md:col-span-8 text-[var(--bb-ink)]/80 leading-relaxed">{s.body}</div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center" data-testid="how-impact-tagline">
          <p className="inline-block font-serif text-2xl md:text-3xl text-[var(--bb-forest)] leading-snug border-y border-[var(--bb-terracotta)]/30 px-6 py-4">
            Books reach hands. <span className="text-[var(--bb-terracotta)]">Training ensures they reach minds.</span>
          </p>
        </div>
      </section>
    </PublicLayout>
  );
}
